import { PresenceAvatarStack } from '@/components/common/PresenceAvatarStack'
import { useWorkspace } from '@/context'
import { useTranslation } from '@/hooks/useTranslation'
import { useWorkspacePresence } from '@/hooks/useWorkspacePresence'

export function WorkspacePresenceIndicator() {
	const { selectedWorkspaceId } = useWorkspace()
	const viewers = useWorkspacePresence(selectedWorkspaceId)
	const { t } = useTranslation()

	if (!selectedWorkspaceId || viewers.length === 0) {
		return null
	}

	return (
		<PresenceAvatarStack viewers={viewers} contextLabel={t('common.presence.viewingWorkspace')} />
	)
}
